import { SET_STATUS_BORRADOR_VIGENTE } from '../constants'
import { ESTADO } from  '../../../commissions/constants';

export function reducer(state, action) {
  if (action.type === SET_STATUS_BORRADOR_VIGENTE) {
      return {
        ...state,
        policies: {
          ...state.policies,
          status: ESTADO.BORRADOR_VIGENTE,
        }
      }
  }
  else{
    return state
  }      
}
